import { render, staticRenderFns } from "./SupervisorFeedbackStatsPanel.vue?vue&type=template&id=c1924b9c&scoped=true&"
import script from "./SupervisorFeedbackStatsPanel.vue?vue&type=script&lang=js&"
export * from "./SupervisorFeedbackStatsPanel.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorFeedbackStatsPanel.vue?vue&type=style&index=0&id=c1924b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1924b9c",
  null
  
)

export default component.exports